import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useImperativeHandle } from 'react';
import { ImageUploader, Toast, Dialog } from 'antd-mobile';
import { v4 as uuidv4 } from 'uuid';
import { utils } from '../../index';
// 限制图片数量
const LimitCount = (props) => {
    // size 单位MB
    const { maxCount = 5, size, list = [], cRef, uploadToken, width = 80, hideUpload = false } = props;
    const [fileList, setFileList] = useState(list);
    function beforeUpload(file) {
        if (size && file.size > utils.calcTimes([size, 1048576])) {
            Toast.show(`请选择小于 ${size}M 的文件`);
            return null;
        }
        return file;
    }
    async function uploadMethods(file) {
        const formData = new FormData();
        const nameArr = file?.name?.split('.');
        const name = nameArr[nameArr.length - 1];
        const key = uuidv4();
        formData.append('file', file);
        formData.append('token', uploadToken);
        formData.append("name", key + `.${name}`);
        formData.append('key', key + `.${name}`);
        return fetch('//upload.qiniup.com/', {
            method: 'POST',
            body: formData, //将formData 赋值给body即可
        })
            .then(response => response.json())
            .then(res => {
            if (res.url) {
                return res;
            }
            else {
                if (res.code === 'token not specified') {
                    Toast.show(`上传token无效,请刷新重试`);
                }
                else {
                    Toast.show(`上传失败,请重新上传或刷新重新`);
                }
                return false;
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }
    // 父组件获取子组件内的数据   暴露给父组件的方法
    useImperativeHandle(cRef, () => ({
        getPictureList: () => {
            return fileList.filter((v) => v && v?.url);
        }
    }));
    return (_jsx(ImageUploader, { value: fileList.filter((v) => v && v?.url), onChange: setFileList, upload: uploadMethods, 
        // multiple
        maxCount: maxCount, showUpload: hideUpload == null ? fileList.length < maxCount : !hideUpload, beforeUpload: beforeUpload, deletable: !hideUpload, preview: true, showFailed: false, onCountExceed: exceed => {
            Toast.show(`最多选择 ${maxCount} 张图片，你多选了 ${exceed} 张`);
        }, onDelete: () => {
            return Dialog.confirm({
                content: '是否确认删除',
            });
        }, style: { '--cell-size': `${width}px` } }));
};
export default LimitCount;
//# sourceMappingURL=index.js.map